import yup from '../../../config/yup';

export const insertValidationSchema = yup.object().shape({
  '@id': yup.string().default(''),
  '@data-type': yup.string().default('command'),
  type: yup.string().default('insert'),
  action: yup.string().default('INSERT').required('Action is required'),
  command: yup
    .string()
    .default('INSERT')
    .required('Command is required')
    .matches(/^INSERT\s+\S+/i, "Command must start with 'INSERT' followed by at least one word"),
});
